
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 83 83","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M25.416 60.717L41.5 44.633l16.083 16.084 3.467-3.467-16.084-16.083L61.05 25.083l-3.467-3.466L41.5 37.7 25.416 21.617l-3.466 3.466 16.083 16.084L21.95 57.25l3.466 3.467zm16.09 21.616c-5.648 0-10.971-1.08-15.967-3.241s-9.365-5.112-13.107-8.852C8.69 66.5 5.738 62.132 3.576 57.139 1.414 52.145.333 46.822.333 41.174c0-5.694 1.08-11.046 3.241-16.056 2.161-5.01 5.112-9.368 8.852-13.073 3.74-3.707 8.108-6.64 13.102-8.802S35.843 0 41.492 0c5.694 0 11.046 1.08 16.056 3.241 5.01 2.161 9.368 5.094 13.074 8.798 3.706 3.704 6.64 8.06 8.801 13.068 2.162 5.008 3.243 10.359 3.243 16.052 0 5.65-1.08 10.972-3.241 15.968s-5.094 9.365-8.798 13.107c-3.704 3.743-8.06 6.695-13.068 8.856-5.008 2.162-10.358 3.243-16.052 3.243zm-.006-4.916c10.088 0 18.652-3.531 25.691-10.592 7.04-7.061 10.558-15.614 10.558-25.658 0-10.09-3.519-18.653-10.558-25.692C60.152 8.436 51.588 4.917 41.5 4.917c-10.045 0-18.598 3.519-25.659 10.558C8.781 22.514 5.25 31.078 5.25 41.167c0 10.044 3.53 18.597 10.591 25.658S31.455 77.416 41.5 77.416z","fill":"#F27474"}})])
          )
        }
      }
    